import { useState } from "react";
import { toast } from "sonner";
import { CheckCircle2 } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { Field } from "./TourInquiryForm";

const INIT = { name: "", email: "", phone: "", message: "", website: "" };

export const ContactForm = () => {
  const [f, setF] = useState(INIT);
  const [errors, setErrors] = useState({});
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    const errs = {};
    if (f.name.trim().length < 2) errs.name = "Please enter your name.";
    if (!/^\S+@\S+\.\S+$/.test(f.email)) errs.email = "Please enter a valid email.";
    if (f.message.trim().length < 10) errs.message = "Please write at least 10 characters.";
    setErrors(errs);
    if (Object.keys(errs).length) return;
    setSending(true);
    try {
      await api.post("/contact", f);
      setDone(true);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSending(false);
    }
  };

  if (done)
    return (
      <div className="card-soft border border-gold-border bg-gold-light p-10" data-testid="contact-success">
        <CheckCircle2 className="h-10 w-10 text-gold" strokeWidth={1.3} />
        <h3 className="mt-5 font-serif text-3xl text-ink">Message received.</h3>
        <p className="mt-3 text-slate-600">Thank you. We will get back to you very soon.</p>
      </div>
    );

  return (
    <form onSubmit={submit} noValidate className="grid gap-5 sm:grid-cols-2" data-testid="contact-form">
      <input className="hp-field" tabIndex={-1} autoComplete="off" value={f.website} onChange={set("website")} aria-hidden="true" name="website" />
      <Field label="Full name" id="contact-name" error={errors.name}>
        <input id="contact-name" className="field-input" value={f.name} onChange={set("name")} data-testid="contact-name-input" />
      </Field>
      <Field label="Email" id="contact-email" error={errors.email}>
        <input id="contact-email" type="email" className="field-input" value={f.email} onChange={set("email")} data-testid="contact-email-input" />
      </Field>
      <div className="sm:col-span-2">
        <Field label="Phone (optional)" id="contact-phone">
          <input id="contact-phone" type="tel" className="field-input" value={f.phone} onChange={set("phone")} data-testid="contact-phone-input" />
        </Field>
      </div>
      <div className="sm:col-span-2">
        <Field label="Message" id="contact-message" error={errors.message}>
          <textarea id="contact-message" rows={5} className="field-input" value={f.message} onChange={set("message")} data-testid="contact-message-input" />
        </Field>
      </div>
      <div className="sm:col-span-2">
        <button type="submit" disabled={sending} className="btn btn-dark w-full sm:w-auto" data-testid="contact-submit-button">
          {sending ? "Sending…" : "Send message"}
        </button>
      </div>
    </form>
  );
};
